<template>
<body>
  
  <div>
    <div class="container2">
      <div class="question">Das Erfassen, Sammeln und Auswerten von Daten aus dem Unternehmensumfeld mit Hilfe von IT-Systemen ist sehr wichtig, um unsere Strategie anzupassen.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="strategie" @input="update" />
      <span :style="warning()" class="rangeValue"> {{strategie}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Wenn wir mit wichtigen strategischen Entscheidungen konfrontiert werden, versuchen wir in der Regel, diese durch datenbasierte Analysen zu entwickeln. </div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="strategie2" @input="update2" />
      <span :style="warning2()" class="rangeValue"> {{strategie2}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Die formelle Verfolgung von signifikanten allgemeinen Trends ist üblich.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="strategie3" @input="update3" />
      <span :style="warning3()" class="rangeValue"> {{strategie3}} </span></div>
    </div>

    <div class="container2">
      <div class="question"> Wir führen häufig Was-wäre-wenn-Analysen zu kritischen Themen durch.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="strategie4" @input="update4" />
      <span :style="warning4()" class="rangeValue"> {{strategie4}} </span></div>
    </div>

    <div class="container2">
      <div class="question"> Wir sind in der Regel die ersten, die neue Dienstleistungen, Produkte oder Marken auf dem Markt einführen. </div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="strategie5" @input="update5" />
      <span :style="warning5()" class="rangeValue"> {{strategie5}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Diese Organisation bietet aktiv offizielle Möglichkeiten für Mitarbeiter, strategische Ideen an das Management weiterzugeben.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="strategie6" @input="update6" />
      <span :style="warning6()" class="rangeValue"> {{strategie6}} </span></div>
    </div>



    <div class="container3">
      <button class="button_save" @click="evaluateForm">auswerten</button>
    </div>


  </div>

    
  </body>
</template>

<script>
  export default {
    props: ["StrategieValue", "StrategieValue2", "StrategieValue3", "StrategieValue4", "StrategieValue5", "StrategieValue6"],
    data(){
      return {
        strategie: this.StrategieValue,
        strategie2: this.StrategieValue2,
        strategie3: this.StrategieValue3,
        strategie4: this.StrategieValue4,
        strategie5: this.StrategieValue5,
        strategie6: this.StrategieValue6
      }
    },
    methods: {   
      update(a){
        this.strategie = a.target.value
      },
      update2(b){
        this.strategie2 = b.target.value
      },
      update3(c){
        this.strategie3 = c.target.value
      },
      update4(d){
        this.strategie4 = d.target.value
      },
      update5(e){
        this.strategie5 = e.target.value
      },
      update6(f){
        this.strategie6 = f.target.value
      },
      warning:function(){
        if(this.strategie == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.strategie == 4)
          return{
            color: "#A1A250",
          }
        if (this.strategie == 3)
          return{
            color: "#E09A34",
          }
        if (this.strategie == 2)
          return{
            color: "#E87735",
          }
        if (this.strategie == 1)
          return{
            color: "#F44336",
          }

      },
      warning2:function(){
        if(this.strategie2 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.strategie2 == 4)
          return{
            color: "#A1A250",
          }
        if (this.strategie2 == 3)
          return{
            color: "#E09A34",
          }
        if (this.strategie2 == 2)
          return{
            color: "#E87735",
          }
        if (this.strategie2 == 1)
          return{
            color: "#F44336",
          }

      },
      warning3:function(){
        if(this.strategie3 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.strategie3 == 4)
          return{
            color: "#A1A250",
          }
        if (this.strategie3 == 3)
          return{
            color: "#E09A34",
          }
        if (this.strategie3 == 2)
          return{
            color: "#E87735",
          }
        if (this.strategie3 == 1)
          return{
            color: "#F44336",
          }

      },
      warning4:function(){
        if(this.strategie4 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.strategie4 == 4)
          return{
            color: "#A1A250",
          }
        if (this.strategie4 == 3)
          return{
            color: "#E09A34",
          }
        if (this.strategie4 == 2)
          return{
            color: "#E87735",
          }
        if (this.strategie4 == 1)
          return{
            color: "#F44336",
          }

      },
      warning5:function(){
        if(this.strategie5 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.strategie5 == 4)
          return{
            color: "#A1A250",
          }
        if (this.strategie5 == 3)
          return{
            color: "#E09A34",
          }
        if (this.strategie5 == 2)
          return{
            color: "#E87735",
          }
        if (this.strategie5 == 1)
          return{
            color: "#F44336",
          }

      },
      warning6:function(){
        if(this.strategie6 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.strategie6 == 4)
          return{
            color: "#A1A250",
          }
        if (this.strategie6 == 3)
          return{
            color: "#E09A34",
          }
        if (this.strategie6 == 2)
          return{
            color: "#E87735",
          }
        if (this.strategie6 == 1)
          return{
            color: "#F44336",
          }

      },
      evaluateForm(){
        if (this.strategie==null) {
          this.strategie='3' 
        } 
        if (this.strategie2==null) {
          this.strategie2='3'
        } 
        if (this.strategie3==null) {
          this.strategie3='3'
        } 
        if (this.strategie4==null) {
          this.strategie4='3'
        } 
        if (this.strategie5==null) {
          this.strategie5='3'
        } 
        if (this.strategie6==null) {
          this.strategie6='3'
        }
        this.$emit('update:StrategieValue', this.strategie)
        this.$emit('update:StrategieValue2', this.strategie2)
        this.$emit('update:StrategieValue3', this.strategie3)
        this.$emit('update:StrategieValue4', this.strategie4)
        this.$emit('update:StrategieValue5', this.strategie5)
        this.$emit('update:StrategieValue6', this.strategie6)
        this.$emit('saved')
      },
    }
  };
</script>


<style>

body{
  margin: 0;
  padding: 0;
  background-color: #fff;
}
.container2{
  position: relative;
  height: 50 px;
  width: 600px;
  margin: 50px auto;
  padding: 10px 10px;
}
.question{
  position: relative;
  width: 600px;
  margin: 10px auto;
  padding: 10px 10px;
}

.slider{
  position: relative;
  width: 600px;
  margin: 10px auto;
  padding: 10px 10px;
}

.container2 .mySlider {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 400px;
  height: 25px;
  background-color: #F5F5F5;
  border-radius: 20px;
  outline:none;
  opacity: 0.7;
  transition: opacity .2s ease-in;
  -webkit-transition: opacity .2s ease-in;

}

.container2 .mySlider:hover{
  opacity: 1;
}

.container2 .mySlider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #F5F5F5;
  cursor: pointer;
  -webkit-transition: all .3s ease-in;
  transition: all .3s ease-in;
  border: 2px solid #F5F5F5;

}

.container2 .mySlider::moz-slider-thumb {
  -moz-appearance: none;
  appearance: none;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #F5F5F5;
  cursor: pointer;
  -webkit-transition: all .3s ease-in;
  transition: all .3s ease-in;
  border: 2px solid #F5F5F5;

}

.container2 .mySlider::-webkit-slider-thumb:hover {
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.5)
}
.container2 .rangeValue {
  position: absolute;
  height: 40px;
  width: 60px;
  right: -20px;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #fff;
  color: #fff;
  font-weight: 600;
  font-family: 'Karla', Arial, Helvetica, sans-serif;
  text-align: center;
  line-height: 38px;
  font-size: 22px;
}

.container2 .rangeValue::before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  background-color: #fff;
  top: 14px;
  left: -6px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid #fff;
  border-left: 1px solid #fff;
  border-right: 1px solid transparent;
  transform: rotate(45deg);
}
.container3 {
  height: 40px;
  width: 150px;
  margin: 20px auto;
  justify-content: center;
}

.button_save {
  font-size: 15px;
  height: 40px;
  width: 130px;
  background-color: #0A2342;
  margin: 0px 10px;
  border-color: #00FFFF;
  color:aliceblue;
  justify-content: center;
  font-family: 'Poppins', 'Arial Black', Gadget, sans;

}


@keyframes anim {
  0%{
    right: -20px;
  }
  25%{
    right: -10px
  }
  50%{
    right: -30px
  }
  70%{
    right: -10px
  }
  100%{
    right: -20px

  }
}





</style>